import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import CampaignsCreateForm from './CampaignsCreateForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createCampaign } from 'store/actions/campaigns/createCampaigns';

class CampaignsCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            dispatchForm,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                callback: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push('/campaigns'));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.campaigns.title'),
                link: '/campaigns',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.campaigns.actions.create') } />

                    <Actions>
                        <ListButton url='/campaigns' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <CampaignsCreateForm
                            form='campaigns_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

CampaignsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createCampaign(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(CampaignsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/campaigns/create/CampaignsCreateContainer.js